export default {
    "apiUrl": 'https://api.htawarawater.com/consumer/',
    "audioUrl": 'https://api.htawarawater.com',
    // "apiUrl": 'http://localhost:8000/consumer/',
    // "audioUrl": 'http://localhost:8000',
}